module.exports = __webpack_public_path__ + "img/combo.eee8bf17.png";